import SellOutlinedIcon from '@mui/icons-material/SellOutlined';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import CategoryOutlinedIcon from '@mui/icons-material/CategoryOutlined';

export const currencies = ['SAR', 'AED', 'KWD', 'BHD', 'QAR', 'OMR', 'EGP', 'USD', 'EUR', 'GBP'];

export const converterConfig = {
  pricebook: {
    title: 'Pricebook',
    description: 'Prices for products.',
    icon: SellOutlinedIcon,
    templateColumns: 'sku, price',
    defaults: {
      pricebookId: '',
      currency: 'SAR',
      parent: '',
      displayName: '',
      onlineFlag: true
    },
    fields: [
      { name: 'pricebookId', label: 'Pricebook ID', required: true },
      { name: 'currency', label: 'Currency', type: 'select', required: true },
      { name: 'parent', label: 'Parent pricebook' },
      { name: 'displayName', label: 'Display name' },
      { name: 'onlineFlag', label: 'Online', type: 'switch', helper: 'Visible on the storefront' }
    ],
    required: ['pricebookId', 'currency']
  },
  inventory: {
    title: 'Inventory',
    description: 'Stock quantities for a warehouse.',
    icon: Inventory2OutlinedIcon,
    templateColumns: 'sku, quantity',
    defaults: {
      listId: ''
    },
    fields: [
      { name: 'listId', label: 'Inventory list ID', required: true }
    ],
    required: ['listId']
  },
  catalog: {
    title: 'Catalog',
    description: 'Products, variations, categories and assignments.',
    icon: CategoryOutlinedIcon,
    templateColumns: 'Products, Variations, Categories, Assignments, CustomAttributes',
    defaults: {
      masterCatalogId: '',
      storefrontCatalogId: '',
      imageBasePath: '/images'
    },
    fields: [
      { name: 'masterCatalogId', label: 'Master catalog ID', required: true },
      { name: 'storefrontCatalogId', label: 'Storefront catalog ID', placeholder: 'Same as master' },
      { name: 'imageBasePath', label: 'Image base path' }
    ],
    required: ['masterCatalogId']
  }
};
